export const tagSearchList = [
  {
    tag: "TAG_LEAD",
    name: "Apply Lead Tag"
  },
  {
    tag: "TAG_REFERRAL",
    name: "Apply Referral Tag"
  },
  {
    tag: "TAG_DEPOSIT",
    name: "Apply Deposit Tag"
  },
  {
    tag: "TAG_SCHEDULE_CALL",
    name: "Scheduled a Call Tag"
  },
  {
    id: 1,
    name: "phone"
  },
  {
    id: 2,
    name: "email_sent"
  },
  {
    id: 3,
    name: "email_received"
  },
  {
    id: 3,
    name: "email_received"
  },
  {
    id: 4,
    name: "skype"
  },
  {
    id: 5,
    name: "chat"
  },
  {
    id: 6,
    name: "sms"
  },
  {
    id: 1,
    name: "disconnects",
    type: "BAD_NUMBER_STATE"
  },
  {
    id: 2,
    name: "Wrong person",
    type: "BAD_NUMBER_STATE"
  },
  {
    id: 3,
    name: "Not calling",
    type: "BAD_NUMBER_STATE"
  },
  {
    id: 4,
    name: "No country code",
    type: "BAD_NUMBER_STATE"
  },
  {
    id: 1,
    name: "Don't like to trade",
    type: "NOT_INTERESTED_STATE"
  },
  {
    id: 2,
    name: "No Money",
    type: "NOT_INTERESTED_STATE"
  },
  {
    id: 3,
    name: "Crazy Person",
    type: "NOT_INTERESTED_STATE"
  },
  {
    tag: "TAG_NA",
    name: "No answer"
  },
  {
    tag: "TAG_ENDED",
    name: "Ended"
  },
  {
    tag: "TAG_WAITING",
    name: "Waiting"
  },
  {
    tag: "TAG_LANGUAGE",
    name: "Apply Language Tag"
  },
  {
    tag: "TAG_TRANSFER",
    name: "Apply Transfer Tag"
  }
];
